import React, { useState } from 'react'

import MyReports from '../../components/MyReports/MyReports';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch} from '@fortawesome/free-solid-svg-icons'

import { ReactDOM } from 'react';



export const SearchBar = () => {
  const [input, setInput] = useState("");
  const [viewMode, setViewMode] = useState("tiles");

    // FetchData component
    const FetchData = ({ values }) => {
      return (
        <div>

          <MyReports SearchValue={values} />
        </div>
      );
    }
    const toggleView = () => {
      setViewMode((prev) => (prev === "tiles" ? "list" : "tiles"));
    };
    const HandleChange = (value) => {
      setInput(value);
    };
    const SeatchBarStyle = {
       padding : '10 px'
    }

    return (
      <div className="container-fluid px-4">

  {/* Heading */}
  <div className="mb-2">
    <label className="stylesearch" style={{ fontSize: '40px', color: 'white', fontWeight: 'bold', marginBottom: '50px', marginTop: '20px', }}>
      Dashboards
    </label>
  </div>

  {/* Search & Toggle Row */}
  <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">

    {/* Left: Search Icon + Input */}
    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
      <FontAwesomeIcon icon={faSearch} style={{ fontSize: '20px', color: '#7bc4ff' }} />
      <input
        type="text"
        placeholder="type to search..."
        value={input}
        onChange={(e) => HandleChange(e.target.value)}
        className="search-input"
        style={{
          fontSize: '18px',
          fontFamily: 'inherit',
          padding: '6px 12px',
          borderRadius: '50px',
          border: '1px solid rgb(46, 80, 141)',
          width: '250px',
          backgroundColor: 'rgb(10, 24, 58)',
          color: 'white',
          lineHeight: "inherit",
        }}
      />
    </div>

    {/* Right: View Mode Toggle Button */}
    <button className="btn-list-view" onClick={toggleView}>
      {viewMode === "tiles" ? "List View" : "Tile View"}
    </button>
  </div>

  {/* Main Report Content */}
  <MyReports SearchValue={input} ViewMode={viewMode} />
</div>



    );
  };
